module.exports = __webpack_public_path__ + "media/logos/logo-confef-f5171e18.png";